import React from 'react'

import { cn } from 'twyne-new.ui'

import { useBubbleTiptap } from '../bubble/Bubble';

import TipTapTooltip from './Tooltip';

export default function FormatterIcon({ active, onClick, icon: Icon, tooltipText, className, style }) {
  const { isBubbleContext } = useBubbleTiptap()
  const activeClass = 'twy-bg-accent text-white hover:bg-blue-500!'
  const hoverClass = isBubbleContext ? 'hover:bg-gray-200' : 'hover:bg-gray-200 dark:hover:bg-gray-950'

  return <TipTapTooltip content={tooltipText}>
    <div className={cn(
      'flex items-center justify-center cursor-pointer p-1 rounded-xs',
      hoverClass,
      active && activeClass,
      className)}
      style={style}
      onClick={onClick}>
      <Icon size={15} />
    </div>
  </TipTapTooltip>
}
